import { HeadingSection, VFlow } from 'bold-ui'
import { RichTextField } from 'components/form'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { MotivoConsultaField, MotivoConsultaFieldModel } from './components/MotivoConsultaField'

export interface SubjetivoFormModel {
  texto: string
  motivos: MotivoConsultaFieldModel[]
}

export interface SubjetivoFormProps {
  name: MetaPath<SubjetivoFormModel>
  cidadao: CidadaoAtendimento
  tipoAtendProf: TipoAtendimentoProfissional
}

export function SubjetivoForm(props: SubjetivoFormProps) {
  const { name, cidadao, tipoAtendProf } = props
  const isAtendimentoOdonto = tipoAtendProf === TipoAtendimentoProfissional.ATENDIMENTO_ODONTOLOGICO

  return (
    <VFlow>
      <RichTextField
        name={name.texto}
        maxLength={4000}
        placeholder='Insira as impressões subjetivas do profissional e as expressadas pelo cidadão.'
      />

      {!isAtendimentoOdonto && (
        <HeadingSection level={3} title='Motivo da consulta'>
          <MotivoConsultaField name={name.motivos} cidadao={cidadao} />
        </HeadingSection>
      )}
    </VFlow>
  )
}
